import React, {useEffect, useLayoutEffect, useRef} from 'react';
import {SwitchThemeButton} from '../theme-switch/switch-theme-button';
import {useIdMirrorTheme} from '../../hooks/use-id-mirror-theme';
import {DarkIdPolo, LightIdPolo} from '../../data/id-mirror-data';
import gsap from 'gsap';
import {
  ImagesWrapper,
  SliderImagesWrapper,
  SliderImg,
  SliderImgWrapper,
} from './ui/slider-image-styles';

export const SliderImageContainer: React.FC = () => {
  const darkImgRef = useRef<HTMLImageElement | null>(null);
  const lightImgRef = useRef<HTMLImageElement | null>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const {isReversed, registerRefs} = useIdMirrorTheme();

  // set initial positions based on current theme state
  useLayoutEffect(() => {
    gsap.set(darkImgRef.current, {x: isReversed ? '100%' : '0%'});
    gsap.set(lightImgRef.current, {x: isReversed ? '0%' : '-100%'});
  }, []);

  // register refs solo cuando el componente es visible (Mobile)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          registerRefs({
            sliderDarkImg: darkImgRef.current,
            sliderLightImg: lightImgRef.current,
            // clear desktop refs
            columnRef: null,
            topImg: null,
            bottomImg: null,
          });
        } else {
          registerRefs({
            sliderDarkImg: null,
            sliderLightImg: null,
          }); // cuando el componente se desmonta -> limpiar refs
        }
      },
      {threshold: 0.1},
    );

    if (wrapperRef.current) observer.observe(wrapperRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <SliderImagesWrapper ref={wrapperRef} className="slider-images-wrapper">
      <ImagesWrapper className="images-wrapper">
        <SliderImgWrapper ref={darkImgRef} className="slider-img-wrapper-dark">
          <SliderImg
            src={DarkIdPolo}
            alt="dark"
            className="slider-image-dark"
          />
        </SliderImgWrapper>
        <SliderImgWrapper
          ref={lightImgRef}
          className="slider-img-wrapper-light"
        >
          <SliderImg
            src={LightIdPolo}
            alt="light"
            className="slider-image-light"
          />
        </SliderImgWrapper>
      </ImagesWrapper>
      <SwitchThemeButton />
    </SliderImagesWrapper>
  );
};
